import APIServices from "../APIServices.js";

/***************************************** ENDPOINTS *****************************************/
const API_GET_OS_DETAILS = "/server/os/get";
const API_GET_DISK_DETAILS = "/server/disk/get";
const API_GET_UNDER_MAINTENANCE = "/maintenance/status";

/***************************************** METHODS *****************************************/
export function getOSDetails() {
  return APIServices.get(API_GET_OS_DETAILS);
}

export function getDiskDetails() {
  return APIServices.get(API_GET_DISK_DETAILS);
}

export function isUnderMaintenance(callback) {
  APIServices.get(API_GET_UNDER_MAINTENANCE).then(res => {
    callback(res);
  });
}

/***************************************** UTILS *****************************************/
// Original Unit = byte
const KILOBYTE = 1000;
const MEGABYTE = KILOBYTE * 1000;
const GIGABYTE = MEGABYTE * 1000;

export function convertDiskUnits(value) {
  if (value / GIGABYTE > 0) {
    return (value / GIGABYTE).toFixed(2) + " GB";
  } else if (value / MEGABYTE > 0) {
    return (value / MEGABYTE).toFixed(2) + " MB";
  } else if (value / KILOBYTE > 0) {
    return (value / KILOBYTE).toFixed(2) + " KB";
  } else {
    return value.toFixed(2) + " B";
  }
}



// WEBPACK FOOTER //
// ./src/services/server/api_server.js